import { ClearEventFormType } from '@mark43/cad-api';
import { useForm } from 'react-hook-form';
import { CLEAR_EVENT_DEFAULT_FORM_VALUES } from '../../dispositions/constants';
import { useClearEventMutation } from '../../dispositions/hooks/use-clear-event-mutation';
import { useEventMetadataStore } from '../../event-panel/event-panel-form/event-metadata';
import { IntegratedFormProvider } from '../../forms/integrated-form-provider';
import { FR_EVENT_DETAILS_TABS } from '../../fr-event-details-page/constants';
import { useOpenFrEventDetails } from '../../fr-event-details-page/hooks/use-open-fr-event-details';
import { useDispositionQuery } from '../../dispositions/hooks/use-disposition-query';
import { useEsriMapStore } from '../../map-window/hooks/use-esri-map-store';

interface FrClearEventContainerProps {
    children: React.ReactNode;
    eventId: number;
}

export function FrClearEventContainer(props: FrClearEventContainerProps) {
    const { children, eventId } = props;

    const openFrEventDetails = useOpenFrEventDetails();
    const mapStore = useEsriMapStore();
    const eventMetadataStore = useEventMetadataStore();

    const clearEventForm = useForm<ClearEventFormType>({
        defaultValues: {
            ...CLEAR_EVENT_DEFAULT_FORM_VALUES,
            eventId,
        },
    });

    const dispositionQuery = useDispositionQuery({ agencyEventId: eventId });

    const clearEventMutation = useClearEventMutation({
        onMutationSuccess: (response) => {
            mapStore.clearSelectedMapLedgerEntity(true);

            // update the store immediately so the UI reflects the cleared state after
            // the event detail page loads without waiting for the realtime update
            const clearedMetadata = response.data.data?.eventPanelView.metadata;
            if (clearedMetadata) {
                eventMetadataStore.setEventPanelMetadata(clearedMetadata);
            }

            openFrEventDetails(eventId, FR_EVENT_DETAILS_TABS.NARRATIVE);
        },
    });

    return (
        <IntegratedFormProvider
            query={dispositionQuery}
            mutation={clearEventMutation}
            form={clearEventForm}
        >
            {children}
        </IntegratedFormProvider>
    );
}
